import { SxProps, TextField, TextFieldProps, Theme } from "@mui/material";
import { Controller, Control, FieldValues, Path } from "react-hook-form";

type Props<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label?: string;
  rules?: object;
  className?: string;
  slotProps?: TextFieldProps["slotProps"];
  helperText?: string;
  type?: React.HTMLInputTypeAttribute | undefined;
  disabled?: boolean;
  errors?: boolean | undefined;
  placeholder?: string;
  sx?: SxProps<Theme>;
  minRows?: number;
  maxRows?: number;
};

export const TextArea = <T extends FieldValues>({
  control,
  name,
  label,
  rules,
  className,
  slotProps,
  helperText,
  type,
  placeholder,
  sx,
  disabled = false,
  minRows = 10,
  maxRows = 16,
}: Props<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          {...(className && { className: className })}
          {...(label && { label: label })}
          multiline
          minRows={minRows}
          maxRows={maxRows}
          placeholder={placeholder}
          fullWidth
          error={!!fieldState.error}
          helperText={fieldState.error?.message || helperText}
          disabled={disabled}
          slotProps={slotProps}
          type={type}
          sx={{
            "& .MuiInputBase-input": {
              color: "#ffffff",
            },
            "& .MuiInputBase-input::placeholder": {
              color: "#ffffff",
            },
            ...sx,
          }}
        />
      )}
    />
  );
};
